import { AttractionProductOption } from '@grpc-clients/external/mercury/v1/attraction/common/attraction-product-option.pb';
import { createSelector } from '@ngrx/store';
import { TravelSearchState, getTravelSearchState } from '../reducers';
export const getActivitiesDetailsFeatureState = createSelector(
  getTravelSearchState,
  (state: TravelSearchState) => state.activitiesDetails
);

export const getActivitiesDetails = createSelector(getActivitiesDetailsFeatureState, (state) => state.details);

export const getActivitiesDetailsLoading = createSelector(getActivitiesDetailsFeatureState, (state) => state.loading);
export const getActivitiesDetailsLoaded = createSelector(getActivitiesDetailsFeatureState, (state) => state.loaded);

export const getActivitiesAvailableRanges = createSelector(
  getActivitiesDetailsFeatureState,
  (state) => state.availableRanges.ranges
);

export const getSortedActivitiesAvailabilityOptions = createSelector(
  getActivitiesDetailsFeatureState,
  (state) => state.availabilityOptions.options
);

export const getActivitiesAvailabilityOptions = createSelector(getSortedActivitiesAvailabilityOptions, (options) => {
  const sortedOptions = options
    ?.filter((option: AttractionProductOption) => !!option.currencyCode)
    .map((result: AttractionProductOption) => {
      const sortedPrices = [...result.pricesByStartTime]
        .filter((times) => !!times)
        .sort((a, b) => a.startTime.value.localeCompare(b.startTime.value));
      return { ...result, pricesByStartTime: sortedPrices };
    })
    .sort((x, y) => {
      const xAvailable = Number(x?.pricesByStartTime?.[0]?.available || 0);
      const yAvailable = Number(y?.pricesByStartTime?.[0]?.available || 0);
      return yAvailable - xAvailable;
    });
  return sortedOptions;
});

export const getAvailabilitySearchData = createSelector(
  getActivitiesDetailsFeatureState,
  (state) => state.availabilitySearchData
);

export const getActivitiesAvailabilityOptionsLoading = createSelector(
  getActivitiesDetailsFeatureState,
  (state) => state.availabilityOptions.loading
);

export const getActivitiesAvailabilityOptionsLoaded = createSelector(
  getActivitiesDetailsFeatureState,
  (state) => state.availabilityOptions.loaded
);
